export interface MapPeriod {
  /** Datas em DD/MM/YYYY, como vêm da rota do mapa (contrato §2, rota 2). */
  inicio: string;
  fim: string;
}

/**
 * Overlay de data do mapa da Visão Geral Agro: janelas de um único dia
 * (caso do ARM) viram "Data: X"; janelas maiores mantêm "Período: X a Y"
 * (decisão de 10/08/2026).
 */
export function formatMapPeriod(period: MapPeriod | null): string {
  if (!period) return 'Período: —';
  if (period.inicio === period.fim) return `Data: ${period.inicio}`;
  return `Período: ${period.inicio} a ${period.fim}`;
}
